"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chang = void 0;
exports.chang = {
    indigo: "#0D1F7A",
    blue: "#0F16AE",
    blueSub: "#A8C5FF",
    liteBlue: "#0059DF",
    liteBlueSub: "#D6E4FF",
};
//# sourceMappingURL=chang.js.map